import { useState, useEffect } from 'react'
import { Box, Typography, Avatar } from '@mui/material'
import defaultAvatar from 'assets/images/default_avatar.png'

const determineAnnvTabIndex = (leave) => {
  if (leave.length > 0) {
    return 1
  }
  return 0
}

const determineBdayTabIndex = (leave, anny) => {
  if (leave.length > 0 && anny.length > 0) {
    return 2
  } else if (leave.length > 0 || anny.length > 0) {
    return 1
  }
  return 0
}

const CalendarEvent = ({ data, filters, setTabState, handleClickDiv, isPast }) => {
  const [publicHoliday, setPublicHoliday] = useState([])
  const [employeeLeave, setEmployeeLeave] = useState([])
  const [birthdays, setBirthdays] = useState([])
  const [workAnniversary, setWorkAnniversary] = useState([])

  useEffect(() => {
    setPublicHoliday(data?.holiday)
    setEmployeeLeave(data?.leave_request)
    setBirthdays(data?.birthday)
    setWorkAnniversary(data?.work_anniversary)
  }, [data])

  return (
    <Box my={0.5}>
      {filters.holiday && (
        <>
          {publicHoliday.length > 1 ? (
            <EventBox
              text={`${publicHoliday.length} Public Holidays`}
              color={'information.main'}
              handleClickDiv={handleClickDiv}
              setTabState={setTabState}
              tabState={0}
              isPast={isPast}
            />
          ) : publicHoliday.length === 1 ? (
            <EventBox
              text={`${publicHoliday[0]?.name}`}
              color={'information.main'}
              handleClickDiv={handleClickDiv}
              setTabState={setTabState}
              tabState={0}
              isPast={isPast}
            />
          ) : null}
        </>
      )}
      {filters.leave && (
        <>
          {employeeLeave.length > 1 ? (
            <EventBox
              text={`${employeeLeave.length} On Leave`}
              color={'error.main'}
              handleClickDiv={handleClickDiv}
              setTabState={setTabState}
              tabState={0}
              isPast={isPast}
            />
          ) : employeeLeave.length === 1 ? (
            <EventBox
              text={` On Leave`}
              color={'error.main'}
              useAvatar
              avatarSrc={employeeLeave[0]?.staff_image}
              handleClickDiv={handleClickDiv}
              setTabState={setTabState}
              tabState={0}
              isPast={isPast}
            />
          ) : null}
        </>
      )}
      {filters.anniversary && (
        <>
          {workAnniversary.length > 1 ? (
            <EventBox
              text={`${workAnniversary.length} Workversaries!`}
              color={'positive.main'}
              handleClickDiv={handleClickDiv}
              setTabState={setTabState}
              tabState={() => determineAnnvTabIndex(employeeLeave)}
              isPast={isPast}
            />
          ) : workAnniversary.length === 1 ? (
            <EventBox
              text={`Workversary!`}
              color={'positive.main'}
              useAvatar
              avatarSrc={workAnniversary[0]?.staff_image}
              handleClickDiv={handleClickDiv}
              setTabState={setTabState}
              tabState={() => determineAnnvTabIndex(employeeLeave)}
              isPast={isPast}
            />
          ) : null}
        </>
      )}
      {filters.birthday && (
        <>
          {birthdays.length > 1 ? (
            <EventBox
              text={`${birthdays.length} Birthdays!`}
              color={'warning.main'}
              handleClickDiv={handleClickDiv}
              setTabState={setTabState}
              tabState={() => determineBdayTabIndex(employeeLeave, workAnniversary)}
              isPast={isPast}
            />
          ) : birthdays.length === 1 ? (
            <EventBox
              text={`Birthday!`}
              color={'warning.main'}
              useAvatar
              avatarSrc={birthdays[0]?.staff_image}
              handleClickDiv={handleClickDiv}
              setTabState={setTabState}
              tabState={() => determineBdayTabIndex(employeeLeave, workAnniversary)}
              isPast={isPast}
            />
          ) : null}
        </>
      )}
    </Box>
  )
}

export default CalendarEvent

const EventBox = ({
  text,
  color,
  useAvatar,
  avatarSrc,
  tabState,
  setTabState,
  handleClickDiv,
  isPast,
}) => {
  const handleClick = () => {
    setTabState(tabState)
    handleClickDiv()
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        backgroundColor: 'gray-background.main',
        opacity: isPast ? '0.35' : null,
        width: 1,
        height: '25px',
        display: 'flex',
        alignItems: 'center',
        p: 0.75,
        gap: 1,
        my: 0.5,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#f1f3f4',
        },
      }}
    >
      <Box minWidth="2px" width="2px" height="18px" bgcolor={color} />
      {useAvatar && (
        <Avatar
          alt="profile"
          sx={{ width: 20, height: 20, bgcolor: 'alternate.main' }}
          src={avatarSrc || defaultAvatar}
        />
      )}
      <Typography noWrap variant="caption">
        {text}
      </Typography>
    </Box>
  )
}
